<template>
    <div id="top">
         <!-- 顶部导航 -->
        <div id="top_labe">
            <div class="tl_comp">
                <div style="line-height:30px;position:relative">
                    你好 <span v-if="token">，{{username}}</span>！欢迎来到{{ companyName }}
                    <span v-if="!token">
                        <a style="cursor:pointer" @click="$router.push('/login')">登录</a>
                        <a style="cursor:pointer" @click="$router.push('/register')">注册</a>
                    </span>
                    <span v-if="token">
                        <a href="#/" @click="quit">退出登录</a>
                    </span>
                    
                    <div class="tl-tool">
                        <div style="height:30px;display:flex;flex-direction: row;align-items: center;justify-content: center;">
                            <div>
                                <a href="#/bom">我的询价</a>
                                <el-divider direction="vertical"></el-divider>
                            </div>
                            <div>
                                <a href="#" style="margin:0px">品牌入驻</a>
                                <el-divider direction="vertical"></el-divider>
                            </div>
                            <div v-for="(item,index) in telephone" :key="index">
                                {{ item }}
                                <el-divider direction="vertical"></el-divider>
                            </div>
                            <div>
                                在线咨询
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
        </div>
        <div id="header">
            <div class="search-box">
                <img src="../assets/logo.png" style="width:360px;" />
                <div class="sc-box">
                    <div style="margin-right: 40px;border:2px solid #057cc3;height:33px;">
                        <input placeholder="请输入产品型号" v-model="input" @input="test" @focus="focus" @keydown="clear" class="search"/>
                        <button class="find" @click="search">库存查询</button>
                    </div>
                    <div @click="rpush" style="cursor: pointer;;margin-right: 120px;padding: 0px 10px 0px 10px;font-size: 14px;border:1px solid gainsboro;height:35px;line-height: 35px;text-align: center;">
                        <i class="el-icon-shopping-cart-2"></i>
                        我的询价单
                    </div>
                </div>    
            </div>
            <div class="lab-box" style="font-size:14px; border-bottom:1px solid gainsboro;">
                <!-- <div @click="Isdisplay" style="width:200px;color:white;background-color:#057cc3;padding:10px 0px 10px 20px;">
                    <i class="el-icon-menu"  style="margin-right:20px;"></i>产品分类
                </div> -->
                <!-- 类型菜单 -->
                <Category></Category>
                <div class="labe"><router-link to="/">首页</router-link></div>
                <div class="labe"><router-link to="/cata">商品目录</router-link></div>
                <div class="labe"><router-link to="/bom">BOM配单</router-link></div>
                <div class="labe"><router-link to="/about/aboutus">关于我们</router-link></div>
                <div class="labe"><router-link to="/about/CompanyNews">新闻动态</router-link></div>
            </div>
           
        </div>
        <el-collapse-transition>
            <div class="sc-fix" v-show="act"> 
                <div class="search-box">
                    <img src="@/assets/logo.png" style="width:200px;" />
                    <div class="sc-box">
                        <div style="margin-right: 40px;border:2px solid #057cc3;height:33px;">
                            <input placeholder="请输入产品型号"  v-model="input" @input="test" @keydown="clear" class="search"/>
                            <button class="find" @click="search">库存查询</button>
                        </div>
                        <div @click="rpush" style="cursor: pointer;;margin-right: 120px;padding: 0px 10px 0px 10px;font-size: 14px;border:1px solid gainsboro;height:35px;line-height: 35px;text-align: center;">
                            <i class="el-icon-shopping-cart-2"></i>
                            我的询价单
                        </div>
                    </div>    
                </div>
            </div>
            
      </el-collapse-transition>
   </div>

</template>

<script>

import { EB } from './EB';
import {index} from '../api';
import Category from './Index/Category.vue';

export default {
  name: 'Top',
  props:['act'],
  computed:{
    username(){
        return this.$store.state.user.userinfo.name;
    },
    token(){
        return this.$store.state.user.token;
    }
  },
  data(){
      return {
        input:'',
        show:false,
        timer:'',
        telephone:[],
        companyName:'',
      }
  },
  methods:{
      Isdisplay(){
        this.show = !this.show
        EB.$emit("isdisplay",this.show);

      },
      test(){
        this.timer = setTimeout(() => {
            
        }, 500);
      },
      clear(s){
        if(s.key == 'Enter'){
            this.search();
        }
        clearTimeout(this.timer)
      },
      search(){
        this.$router.push({
            path:'/search',
            query:{
                name:this.input.replaceAll(" ",'')
            }
        })
        this.input = '';
      },
      focus(){
        if(this.input.replaceAll(" ",'') != ''){
            console.log(1)
        }
      },
      rpush(){
        this.$router.push('/bom')
      },
      quit(){
        localStorage.removeItem('token');
        this.$router.go(0);
      }
  },
  created(){
    index({comp:'top'}).then(res=>{
        this.telephone = res.telephone;
        this.companyName = res.webname
    })
  },
  mounted(){
    if(localStorage.getItem('token')){
        this.$store.dispatch('userinfo',{token:localStorage.getItem('token')});
        localStorage.removeItem('uid')
        return;
    }
    if(!localStorage.getItem('uid') && !localStorage.getItem('token')){
        this.$store.dispatch('getUid').then(res=>{
            localStorage.setItem('uid',res);
        });
    }
    
  },
  components: {
    Category
    
  }
}
</script>

<style>
    .el-divider--vertical{
        background: gray;
        margin-top: -2px;
    }

    
    .find:hover{
        background-color: #2d8cf0;
        cursor: pointer;
        color: white;
    }

    .sc-fix{
        position:fixed;width:100%;
        z-index: 9999;top:0px;
        background:white;
        border-bottom: 2px solid rgb(5, 124, 195);
        height: 75px;
    }
    /* 顶部 */

    #top_labe{
        width:100%;background:#e3e4e5;height: 30px;
    }

    .tl_comp{
        width:1190px;height:30px;margin:0 auto;font-size:12px;
        background:#e3e4e5;
    }

    .tl-tool{
        display:inline-block;position: absolute;right:0px;
    }   

    .tl-text a{
        margin: 0px;
    }

    /* 头部 */

    #header{
         background: white;
         border-bottom:1px solid gainsboro;
    }

    .search{
        width:400px;border:none;outline:none;padding: 6px;height: 19px;
    }

    .sc-box{
        display:flex;align-items: center;
        position: absolute;right: 0px;
    }

    .lab-box{
        position:relative;width:1190px;margin:0 auto;
        margin-top: 21px;top:1px;display:flex;
        align-items: center;flex-direction: row;
    }

    .search-box{
        position:relative;width:1190px;margin:0 auto;display:flex;
        align-items: center;flex-direction: row;
    }

    .find{
        color:white;height:33px;border:none;
        outline:none;width:100px;background: #057cc3;
        
    }

    .labe{
        margin-left: 80px;
    }

    a{
        text-decoration: none;
        color: black;
        margin-left: 10px;
    }

    @media screen and (max-width:1200px) {
        #header{
            width:1190px;
        }
        
    }

</style>